/**
 * The Symagic Server PlanItem entity.
 * @author Tom Verschoore de la Houssaije
 */
import * as moment from 'moment';
import { PROP_ORIGINAL_RESOURCE_OID } from '../../domain.service';
/**
 * The Symagic Server PlanItem entity.
 * @export
 * @class PlanItem
 * @implements {Entity}
 */
var PlanItem = /** @class */ (function () {
    function PlanItem() {
    }
    Object.defineProperty(PlanItem.prototype, "Resource", {
        /**
         * Gets the resource of the PlanItem item.
         * @type {Entity}
         */
        get: function () {
            // This is needed to override breeze.js navigation property.
            if (this.entityAspect && this.entityAspect.entityState.isDetached()) {
                return undefined;
            }
            var item = this.Item;
            if (!item) {
                return null;
            }
            return item['Resource'];
        },
        /**
         * Sets the resource of the PlanItem item
         */
        set: function (value) {
            var item = this.Item;
            if (!item) {
                return;
            }
            // Needed to update the planboard.
            item[PROP_ORIGINAL_RESOURCE_OID] = item['Resource_Oid'];
            item['Resource'] = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calculates the effort by factoring the ratio of overlap with a given timeslot.
     * @param {moment.Moment} start The start of the timeslot
     * @param {moment.Moment} finish The finish of the timeslot.
     * @returns {number} The effort ratio in seconds
     */
    PlanItem.prototype.overlapEffort = function (start, finish) {
        var factor = this.Item ? this.Item['SumFactor'] : 0;
        if (factor === 0) {
            return 0;
        }
        if (start.isSameOrAfter(this.Finish)) {
            return 0;
        }
        if (finish.isSameOrBefore(this.Start)) {
            return 0;
        }
        var planStart = moment(this.Start);
        var planFinish = moment(this.Finish);
        var overlapStart = start.isAfter(planStart) ? start : planStart;
        var overlapFinish = finish.isBefore(planFinish) ? finish : planFinish;
        var overlap = moment.duration(overlapFinish.diff(overlapStart)).asSeconds();
        if (this.ItemClass !== 'Assignment' || this.Item['Appointment']) {
            // Geen werk druk planning
            return factor * overlap;
        }
        var effort = this.Item['Effort'];
        var duration = moment.duration(planFinish.diff(planStart)).asSeconds();
        if (duration === 0 || (start.isSameOrBefore(this.Start) && finish.isSameOrAfter(this.Finish))) {
            // Ik kan de gehele werkdruk geven want
            // de Assignment valt binnen de getoonde periode
            return factor * moment.duration(effort).asSeconds();
        }
        // Ik geef de fractie (overlap / duration) van de werkdruk want
        // de Assignment is groter dan de getoonde periode.
        return factor * (overlap / duration) * moment.duration(effort).asSeconds();
    };
    return PlanItem;
}());
export { PlanItem };
